import { Box, Flex, Text } from "@chakra-ui/react";

interface LegendDiscreteStepProps {
  label: string;
  color: string;
}

export function LegendDiscreteStep({ label, color }: LegendDiscreteStepProps) {
  return (
    <Flex title={label} alignItems="center">
      <Box h="12px" w="24px" backgroundColor={color} borderRadius={2} />
      <Text
        fontSize={10}
        fontWeight={600}
        ml={1}
        color="grey"
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
      >
        {label}
      </Text>
    </Flex>
  );
}
